module.exports = __webpack_public_path__ + "public/images/program/program-6.12822404387e493b857b887e370cd6d7.png";